import { t } from 'i18next';
import { type WorkshopBusinessId } from '@icare/types';

import { type CustomerIdentity, PersonTypes } from '../apis/customer/customer.types';
import { type MemberCountry } from '../apis/member/member.types';

export const getCountryCode = (country: MemberCountry) => country.codeISO2;

export const getCustomerName = (customer: CustomerIdentity | undefined | null) => {
  if (!customer) return '';
  switch (customer.personType) {
    case PersonTypes.customer:
      return `${customer.lastname} ${customer.firstname || ''}`;
    case PersonTypes.company:
      return customer.companyName ?? `${customer.lastname} ${customer.firstname || ''}`;
    default:
      return `DECATHLON ${customer}`;
  }
};

export const isCardNumber = (value: string) => /209\d{10}/.test(value);
export const isEmail = (value: string | undefined) => /[a-zA-Z0-9_.-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}/.test(value ?? '');

export const getDecathlonCustomerName = (contextId: WorkshopBusinessId | undefined) => {
  if (!contextId) return '';
  const businessType = t(`intervention.business.type.${contextId}`);
  return `${t('decathlon')} - ${businessType}`;
};
